var config = ({
    'url_api' : process.env.VUE_APP_API_HOST,
    'headers_api' : { headers: {
            'Authorization': 'Bearer $2y$10$HlNraRAMYuJSGkY5R06EI.qMHAbFs0V6aXrq4212JP1SW0iOHNwYW',
            'Content-Type' : 'application/json',
        }},
    'environment' : process.env.NODE_ENV,
    'Content-Type': 'multipart/form-data'
});

export default config;
